import React, {useEffect} from 'react';

import { Route, Routes, useLocation } from 'react-router-dom';

import PlayerPage from './projects/dnd/playerView/components/PlayerPage';
import WhoAreYou from './projects/dnd/playerView/components/PlayerUI/PlayerPicker/WhoAreYou';
import DmView from './projects/dnd/dmView/components/DmView';
import ErrorBoundary from "./projects/dnd/dmView/components/ErrorBoundary"; 
import Users from "./projects/dnd/dmView/components/users/Users"; 

import Blog from './projects/blog/components/Blog';
import Pantheon from './projects/king/components/Pantheon';

import HowTo from './projects/dnd/dmView/components/SideMenu/HowToDMB';
import ReactGA from "react-ga4";

function App() {

    const location = useLocation();
    useEffect(() => {
        // Initialize GA with your Measurement ID
        ReactGA.initialize("G-R3XHSS7071", { debug: false });

        // Trigger page view on route change
        ReactGA.send({ hitType: "pageview", page: location.pathname });
    }, [location]);

    return (        
        <ErrorBoundary>
            <Routes>
                <Route path="/" element={<DmView />}/>
                <Route path="/playerView/:sessionID/*" element={<PlayerPage/>} />
                <Route path="/join/:sessionID" element={<WhoAreYou/>} />
                <Route path="/help" element={<HowTo/>} />
                <Route path="/users" element={<Users/>} />
                <Route path="/king/" element={<Pantheon />} />
                <Route path="/blog" element={<Blog/>}/>
            </Routes>
        </ErrorBoundary>
    );
}

export default App;
